import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface CreateMealPlanHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  onBack?: () => void;
  backLabel?: string;
  actions?: React.ReactNode;
  inlineBackButton?: boolean;
}

const CreateMealPlanHeader: React.FC<CreateMealPlanHeaderProps> = ({
  title,
  description,
  backTo = '/meal-planning',
  onBack,
  backLabel = 'Back to Meal Planning',
  actions,
  inlineBackButton = false,
}) => {
  const backButton = onBack ? (
    <Button variant="ghost" size="sm" className="gap-1" onClick={onBack}>
      <ArrowLeft className="h-4 w-4" />
      {backLabel}
    </Button>
  ) : (
    <Link to={backTo}>
      <Button variant="ghost" size="sm" className="gap-1">
        <ArrowLeft className="h-4 w-4" />
        {backLabel}
      </Button>
    </Link>
  );

  if (inlineBackButton) {
    return (
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          {backButton}
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {description && <p className="text-gray-600 mt-1">{description}</p>}
          </div>
        </div>
        {actions}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center">{backButton}</div>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex-1">
          <h1 className="text-3xl font-bold">{title}</h1>
          {description && <p className="text-gray-600 mt-2">{description}</p>}
        </div>
        {actions}
      </div>
    </div>
  );
};

export default CreateMealPlanHeader;

